module.exports = __webpack_public_path__ + "img/lilo.67dc5ba4.png";